import { Phone, Mail, MapPin, Clock, Navigation, AlertCircle } from "lucide-react";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";

const MAP = "https://www.google.com/maps?q=164+Albury+Street,+Holbrook+NSW+2644&output=embed";

export default function Contact() {
  const cards = [
    [Phone, "Reception", "02 6036 2077", "tel:0260362077"],
    [Mail, "Email", "admin@byerfountainmotorinn.com.au", "mailto:admin@byerfountainmotorinn.com.au"],
    [MapPin, "Address", "164 Albury Street, Holbrook NSW 2644", MAP.replace("&output=embed", "")],
  ];
  return (
    <div>
      <PageHero overline="Get In Touch" title="Contact & Directions"
        subtitle="We're right on the Hume Highway in the heart of Holbrook — easy to find, easy to love."
        image="/static/generated/byer-front-day.png" />

      <section className="bg-[#F7F5F0] py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            {cards.map(([Icon, t, v, href], i) => (
              <Reveal key={t} delay={i * 0.08}>
                <a href={href} target={t === "Address" ? "_blank" : undefined} rel="noreferrer"
                  className="block p-8 rounded-2xl bg-white soft-shadow border border-[#0B192C]/5 hover:border-[#D4AF37]/50 transition-colors h-full" data-testid={`contact-${t.toLowerCase()}`}>
                  <Icon size={26} className="text-[#D4AF37] mb-4" />
                  <p className="overline text-[#0B192C]/50 mb-1">{t}</p>
                  <p className="font-serif text-2xl text-[#0B192C] break-words">{v}</p>
                </a>
              </Reveal>
            ))}
          </div>

          <div className="grid md:grid-cols-3 gap-8 items-start">
            <Reveal className="md:col-span-2">
              <div className="rounded-2xl overflow-hidden soft-shadow h-[460px]">
                <iframe title="map" src={MAP} className="w-full h-full border-0" loading="lazy" data-testid="google-map" />
              </div>
            </Reveal>
            <Reveal delay={0.1} className="space-y-5">
              <div className="p-6 rounded-2xl bg-white soft-shadow">
                <Clock size={22} className="text-[#D4AF37] mb-3" />
                <h3 className="font-serif text-2xl text-[#0B192C] mb-2">Reception Hours</h3>
                <p className="text-[#222]/70 text-sm">Monday–Friday: <b>9:00 AM – 9:00 PM</b><br/>Saturday–Sunday: <b>10:00 AM – 8:00 PM</b></p>
                <p className="text-[#222]/60 text-xs mt-3">Check-in from <b>1:00 PM</b> · Check-out by <b>10:00 AM</b>. For arrivals outside reception hours, please contact the motel in advance to arrange late check-in.</p>
              </div>
              <div className="p-6 rounded-2xl bg-white soft-shadow">
                <Navigation size={22} className="text-[#D4AF37] mb-3" />
                <h3 className="font-serif text-2xl text-[#0B192C] mb-2">Directions</h3>
                <p className="text-[#222]/70 text-sm">On the Hume Highway (Albury Street) in central Holbrook — roughly halfway between Sydney and Melbourne. Ample free parking on-site.</p>
              </div>
              <div className="p-6 rounded-2xl bg-[#0B192C] text-white">
                <AlertCircle size={22} className="text-[#D4AF37] mb-3" />
                <h3 className="font-serif text-2xl mb-2">Late arrival?</h3>
                <p className="text-white/70 text-sm">Arriving after hours? No problem — just call ahead on <a href="tel:0260362077" className="text-[#D4AF37]">02 6036 2077</a> and we'll arrange your check-in.</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
